import Loading from "../Loading";
import Loadable from "react-loadable";

// main carousel
export const Carousel = Loadable({
  loader: () => import("./home-page-components/Carousel"),
  loading: Loading
});

// newsfeed
export const NewsFeed = Loadable({
  loader: () => import("./home-page-components/NewsFeed"),
  loading: Loading
});

// feature set
export const FeatureSet = Loadable({
  loader: () => import("./home-page-components/FeatureSet"),
  loading: Loading
});



// WEBPACK FOOTER //
// ./src/components/home-page/HomepageLazyLoading.js